import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useUser } from './auth'
import { Spin } from 'antd'

export default function Home () {
  const user = useUser()
  const navigate = useNavigate()

  useEffect(() => {
    if (user) {
      // Redirect logged-in users to dashboard
      navigate('/dashboard')
    } else if (user === null) {
      // Redirect non-authenticated users to login
      navigate('/account/login')
    }
  }, [user, navigate])

  // Show loading while checking auth
  return (
    <div style={{ 
      minHeight: 'calc(100vh - 64px)', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center'
    }}>
      <Spin size="large" />
    </div>
  )
}
